import type {CourseApiModel, CourseExpandedCommon} from '../../../api/course';
import type {CoreCoachCoursesStopParams} from '../../../api/types/core/methods';
import type {AsyncStrategy, BaseConfig} from '../utils';

import {courseExpandCommon, courseStore} from '../../../api/course';
import {alert} from '../../../components/alert';
import {isMeCoachForEntity} from '../../../utils/entity/isMeCoachForEntity';
import {AppError} from '../../../utils/errors/app';
import {COMMAND} from '../utils';

export {courseStop};

type Config = BaseConfig<Omit<CoreCoachCoursesStopParams, '_id'>> & {
  entity: CourseApiModel;
};

const strategy: AsyncStrategy<Config> = async (roles, config) => {
  if (isMeCoachForEntity(config.entity)) {
    return roles.coach(config);
  } else {
    return roles.client(config);
  }
};

async function courseStop(config: Config) {
  return strategy({client: asClient, coach: asCoach}, config);
}

courseStop.asClient = asClient;
courseStop.asCoach = asCoach;

async function asClient(_config: Config) {
  throw new AppError('not_allowed');
}

async function asCoach({entity, params}: Config) {
  if (!(await alert.confirm())) {
    return COMMAND.CANCEL;
  }

  const stoppedCourse = (await courseStore.stop(entity, {
    ...params,
    expand: courseExpandCommon,
  })) as CourseExpandedCommon;

  await courseStore.localUpdate(entity, stoppedCourse);

  return stoppedCourse;
}
